<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 39.22 39.22"
    style="enable-background: new 0 0 39.22 39.22"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
  >
    <g>
      <path
        class="text-gray-300"
        d="M36.22,38.26H2.98c-1.11,0-2.02-0.9-2.02-2.02V3.01c0-1.11,0.9-2.02,2.02-2.02h33.23
		c1.11,0,2.02,0.9,2.02,2.02v33.23C38.23,37.36,37.33,38.26,36.22,38.26z"
      />
    </g>
    <g>
      <path
        class="text-gray-500"
        d="M36.22,39.26H2.98c-1.66,0-3.02-1.35-3.02-3.02V3.01c0-1.66,1.35-3.02,3.02-3.02h33.23
		c1.66,0,3.02,1.35,3.02,3.02v33.23C39.24,37.9,37.88,39.26,36.22,39.26z M2.98,1.99c-0.56,0-1.02,0.46-1.02,1.02v33.23
		c0,0.56,0.46,1.02,1.02,1.02h33.23c0.56,0,1.02-0.46,1.02-1.02V3.01c0-0.56-0.46-1.02-1.02-1.02H2.98z"
      />
    </g>
    <path
      class="bg-gray-500"
      d="M27.51,4.32c-0.55,0-1,0.45-1,1s0.45,1,1,1h3.99l-25.2,25.2v-3.99c0-0.55-0.45-1-1-1s-1,0.45-1,1v7.4h7.4
	c0.55,0,1-0.45,1-1s-0.45-1-1-1H7.71l25.2-25.2v3.99c0,0.55,0.45,1,1,1s1-0.45,1-1v-7.4H27.51z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
